(() => {
  const desktopHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const OPEN_DELAY = 140;
  const CLOSE_DELAY = 260;
  let timers = new WeakMap();

  const menus = () => Array.from(document.querySelectorAll('.header__inline-menu details.mega-menu'));
  const layout = (details) => {
    const content = details.querySelector(':scope > .mega-menu__content');
    const summary = details.querySelector(':scope > summary');
    const header = details.closest('.header');
    const wrapper = details.closest('.header-wrapper');
    if (!content || !summary || !header || !wrapper || window.innerWidth < 990) return;

    const columns = Math.max(1, content.querySelectorAll(':scope > .mega-menu__list > li').length);
    const wrapperBounds = wrapper.getBoundingClientRect();
    const width = Math.min(wrapperBounds.width, window.innerWidth);
    const left = 0;

    content.style.setProperty('--phase1-mega-columns', String(columns));
    content.style.setProperty('--phase1-mega-width', `${Math.round(width)}px`);
    content.style.setProperty('--phase1-mega-left', `${Math.round(left)}px`);
  };
  const setExpanded = (details, expanded) => {
    const summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', String(expanded));
  };
  const close = (details) => {
    window.clearTimeout(timers.get(details));
    details.removeAttribute('open');
    setExpanded(details, false);
  };
  const closePredictiveSearch = () => {
    document.querySelectorAll('.header__search-inline predictive-search').forEach((search) => search.close?.());
  };
  const open = (details) => {
    closePredictiveSearch();
    menus().forEach((menu) => { if (menu !== details) close(menu); });
    details.setAttribute('open', '');
    setExpanded(details, true);
  };
  const schedule = (details, fn, delay) => {
    window.clearTimeout(timers.get(details));
    timers.set(details, window.setTimeout(fn, delay));
  };
  const bind = () => {
    menus().forEach((details) => {
      layout(details);
      if (details.dataset.phase1HoverBound === 'true') return;
      details.dataset.phase1HoverBound = 'true';
      const parentLink = details.querySelector(':scope > summary .header__menu-parent-link');
      parentLink?.addEventListener('click', (event) => event.stopPropagation());
      details.addEventListener('pointerenter', () => {
        if (desktopHover.matches) schedule(details, () => open(details), OPEN_DELAY);
      });
      details.addEventListener('pointerleave', () => {
        if (desktopHover.matches) schedule(details, () => close(details), CLOSE_DELAY);
      });
      details.addEventListener('focusin', () => {
        if (desktopHover.matches) open(details);
      });
      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          close(details);
          details.querySelector(':scope > summary')?.focus();
        }
      });
    });
    document.querySelectorAll('.header__search-inline input[type="search"]').forEach((input) => {
      if (input.dataset.phase1MenuCloseBound === 'true') return;
      input.dataset.phase1MenuCloseBound = 'true';
      input.addEventListener('focus', () => menus().forEach(close));
      input.addEventListener('input', () => menus().forEach(close));
    });
  };
  bind();
  document.addEventListener('shopify:section:load', bind);
  desktopHover.addEventListener('change', (event) => {
    if (!event.matches) menus().forEach(close);
  });
  window.addEventListener('resize', () => menus().forEach(layout));
})();
